import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import { createColumnHelper } from "@tanstack/react-table"
import DataTable from "../../../components/dataTable/DataTable"
import iSituacoesDadosDto from "./dto/dados-situacoes.dto"

const columnHelper = createColumnHelper<iSituacoesDadosDto>()

const defaultColumns = [
    columnHelper.accessor('codigo', {
        header: 'ID',
        size: 10,
        minSize: 10,
        maxSize: 150
    }),
    columnHelper.accessor('descricao', {
        header: 'Descrição'
    }),
    columnHelper.accessor(row => row.situacao === 1 ? 'Ativo' : 'Inativo', {
        header: 'Status'
    }),
]

const defaultOrder:any = []

function SituacoesPage() {

    const [situacoes, setSituacoes] = useState<iSituacoesDadosDto[]>([])

    useEffect(() => {
        document.title = "Situações | OB PORTUS"

        const listar = async () => {
            const api = await reqGetNew(ApiEndpoints.painelControle.situacoes.todos)

            if (api.status === 200) {
                const aux:iSituacoesDadosDto[] = api.data
                setSituacoes(aux)
            }
        }

        listar()
    }, [])

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = situacoes[idx]
        const link = `/painelControle/situacoes/editar?id=${reg.codigo}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = situacoes[idx]
        const link = `/painelControle/situacoes/editar?id=${reg.codigo}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">

            <div className="div-row-space-between">
                <h1 id="titleMain">Situações</h1>
                <Button onClick={() => {
                    // window.open(`/painelControle/empresas/cadastrar`)
                    window.location.assign(`/painelControle/situacoes/cadastrar`)
                }}>Cadastrar</Button>
            </div>

            <br></br>

            {<DataTable dados={situacoes} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}

        </div>
    )

}

export default SituacoesPage